import {NachrichtSummary} from "../../../core/model/nachricht/nachricht";
import {InjectionToken} from "@angular/core";
import { NachrichtAction } from '../nachricht-action-buttons/nachricht-action.enum';
import {Observable} from "rxjs";
import {OrdnerEnum} from "../../../core/model/ordner.enum";
import {ModalComponent} from "../modal/modal.component";

export interface NachrichtActionHandler {


    registerModal(name: string, ref: ModalComponent): void;

    handleAction(action: NachrichtAction, nachricht: NachrichtSummary, confirmed?: boolean): Observable<OrdnerEnum>;
}

export const NachrichtActionHandlerToken = new InjectionToken<NachrichtActionHandler>('NachrichtActionHandler');